import axios from 'axios';
import { Config } from '../../../config';

// Admin API instance
export const instance = axios.create({
  baseURL: Config.getFullApiUrl(),
});

// Set authorization header
export const setToken = token => {
  if (token) {
    return (instance.defaults.headers.authorization = `Bearer ${token}`);
  }
  instance.defaults.headers.authorization = '';
};

// Expert API instance
export const expertInstance = axios.create({
  baseURL: Config.BASE_URL,
});

// Log API configuration in development
if (Config.isDevelopment()) {
  console.log('🔧 API Configuration:', {
    adminBaseUrl: instance.defaults.baseURL,
    expertBaseUrl: expertInstance.defaults.baseURL,
    environment: Config.ENVIRONMENT,
  });
}
